(function ($) {

	$(window).click(close_options);

	$("button.single-product-summary__variations_dropdown").click(function (e) {
		e.stopPropagation() // To prevent window click hook
		toggle_options()
	})

	$("#form-product-variant-detail").change(load_product_variant_detail)

	// Change dropdown title
	$("input[name='product_variant_id']").change(function () {
		$("button.single-product-summary__variations_dropdown span").text($(this).data("selected-title"))
	})

	function open_options() {
		$(".single-product-summary__variations_select").addClass("opened")
	}

	function close_options() {
		$(".single-product-summary__variations_select").removeClass("opened")
	}

	function toggle_options() {
		$(".single-product-summary__variations_select").toggleClass("opened")
	}

	function remove_modals() {
		$("[data-modal-id=\"doruceni-a-doprava\"]").remove()
	}

	// Close on click

	function show_loading() {
		$('.single-product-variant').css('opacity', '0.5')
	}

	let request;

	function load_product_variant_detail(e) {

		e.preventDefault()

		// Abort previous request if is loading
		if (typeof request !== "undefined") {
			request.abort()
		}

		// Show loading
		show_loading()

		// Remove loaded modals
		remove_modals()

		let url = $(this).attr("action"),
			data = $(this).serializeArray()

		request = gp_ajax({
			url: url,
			type: "post",
			dataType: "json",
			data: data
		})
			.done((response, textStatus, jqXHR) => {
				jQuery(document).trigger('product_variant_detail_loaded')
			})
	}

})(jQuery);